import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPrivilege } from '@utils/data/rbacService';

interface RouteGuardProps {
  condition: boolean;
  redirectTo: string;
  children: React.ReactNode;
  requiredPrivileges?: string[];
  privilegeCheckMode?: 'AND' | 'OR'; // 'AND' requires all privileges, 'OR' requires any privilege
  userResponse: any
}

function RouteGuard({
  condition,
  redirectTo,
  children,
  requiredPrivileges = [],
  privilegeCheckMode = 'AND',
  userResponse,
}: RouteGuardProps) {
  const userPrivileges = new Set(userResponse?.user?.Privilege);
  if (!condition) {
    return <Navigate to={redirectTo} replace />;
  }
  if (requiredPrivileges && requiredPrivileges.length > 0) {
    let hasRequiredPrivileges = false;
    if (privilegeCheckMode === 'AND') {
      // Require ALL privileges to be present
      // eslint-disable-next-line
      hasRequiredPrivileges = requiredPrivileges.every((privilege) => hasPrivilege(userPrivileges, privilege));
    } else if (privilegeCheckMode === 'OR') {
      // Require ANY privilege to be present
      // eslint-disable-next-line
      hasRequiredPrivileges = requiredPrivileges.some((privilege) => hasPrivilege(userPrivileges, privilege));
    }
    if (!hasRequiredPrivileges) {
      return <Navigate to="/" replace />;
    }
  }
  document.title = 'Agent Garden';
  // eslint-disable-next-line
  return <>{children}</>;
}
RouteGuard.defaultProps = {
  requiredPrivileges: [],
  privilegeCheckMode: 'AND',
};

export default RouteGuard;
